export const EVALUATIONS_COMPLETED = "Surveys Completed";



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/sport-table/constants.ts